import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SecondaryButton } from '@components/button/secondary-button/secondary-button';
import { YearPanelMonth, YearPanelRowTarget } from '../../data-monitoring-view.model';

/** Problems per month of the year, with the worst rows of each month as jump links. */
@Component({
  selector: 'app-data-monitoring-year-panel',
  standalone: true,
  imports: [TranslateModule, SecondaryButton],
  templateUrl: './data-monitoring-year-panel.html',
  styleUrl: './data-monitoring-year-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataMonitoringYearPanelComponent {
  readonly year = input.required<number>();
  readonly totalProblems = input.required<number>();
  readonly months = input.required<YearPanelMonth[]>();

  readonly openMonth = output<number>();
  readonly goToRow = output<YearPanelRowTarget>();
}
